import { GET_AUDITS } from "../../actions/audits/audits";

export default function audits(state = [], action) {
  switch (action.type) {
    case GET_AUDITS:
      return action.audits;
    default:
      return state;
  }
}
